import React, { useState, useEffect } from 'react';
import XRayHero from '../XRayHero.js'; // Keep using the component we made!
import ReactGA from "react-ga4";

// --- ASSET IMPORTS (Replace these later!) ---
import bg from '../../img/background.png';
import charsClothed from '../../img/girls_clothed.png';
import charsSecret from '../../img/girls_secret.png';
import angelImg from '../../img/celia.png'
import succubusImg from '../../img/akala.png'
import gameLogoHor from '../../img/xray_logo.png'
import gameLogoImg from '../../img/xray_logo_vert.png'


export default function XRPage() {
  // --- RESPONSIVE STATE ---
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const styles = {
    page: {
      backgroundColor: 'transparent', 
      color: '#f8fafc', 
      fontFamily: '"Segoe UI", Roboto, Helvetica, Arial, sans-serif',
      minHeight: '100vh',
      overflowX: 'hidden', // Extra safety net
    },
    heroSection: {
      width: '100%',
      // CRITICAL FIX: Match the child's height so there is no empty gap!
      height: isMobile ? '45vh' : '90vh', 
      position: 'relative',
      borderBottom: '5px solid #ff007f', 
    },
    content: {
      maxWidth: '1000px',
      margin: '0 auto',
      padding: isMobile ? '40px 15px' : '60px 20px', // Smaller padding on mobile
      backgroundColor: '#111c3a', 
      marginTop: '-50px', 
      borderRadius: '12px',
      position: 'relative',
      boxShadow: '0 15px 50px rgba(0,0,0,0.5)', 
      zIndex: 10,
      border: '1px solid #1c2b4d', 
    },
    flankingChar: {
      display: isMobile ? 'none' : 'block', // CRITICAL FIX: Hide on mobile!
      position: 'absolute',
      bottom: '0', 
      height: '700px', 
      width: 'auto',
      zIndex: -1, 
      pointerEvents: 'none', 
    },
    angelStyle: {
      left: '-210px', 
    },
    succubusStyle: {
      right: '-210px', 
      transform: 'scaleX(-1)',
    },
    title: {
      fontSize: '3.5rem',
      fontWeight: '900',
      color: '#ffffff', 
      textAlign: 'center',
      marginBottom: '10px',
      letterSpacing: '-1px',
      textTransform: 'uppercase',
    },
    subtitle: {
      fontSize: isMobile ? '1.1rem' : '1.4rem', // Shrink font slightly on mobile
      color: '#94a3b8', 
      textAlign: 'center',
      marginBottom: '50px',
      fontWeight: '300',
    },
    badgeContainer: {
      display: 'flex',
      justifyContent: 'center',
      gap: '10px',
      marginBottom: '40px',
      flexWrap: 'wrap',
    },
    badgePrimary: {
      backgroundColor: '#ff007f', 
      color: '#fff',
      padding: '6px 16px',
      borderRadius: '20px', 
      fontSize: '0.85rem',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      letterSpacing: '1px',
      boxShadow: '0 4px 10px rgba(255, 0, 127, 0.3)', 
    },
    badgeSecondary: {
      backgroundColor: 'rgba(255, 0, 127, 0.1)', 
      color: '#ff007f', 
      border: '1px solid #ff007f',
      padding: '6px 16px',
      borderRadius: '20px',
      fontSize: '0.85rem',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      letterSpacing: '1px',
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
      gap: '40px',
      marginBottom: '60px',
    },
    featureCard: {
      padding: '30px',
      backgroundColor: '#162447', 
      borderRadius: '8px',
      borderLeft: '4px solid #ff007f', 
      boxShadow: '0 5px 15px rgba(0,0,0,0.2)', 
    },
    featureTitle: {
      fontSize: '1.2rem',
      fontWeight: 'bold',
      marginBottom: '10px',
      color: '#f8fafc', 
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    },
    text: {
      color: '#cbd5e1', 
      lineHeight: '1.6',
    },
    buttonGroup: {
      display: 'flex',
      flexDirection: isMobile ? 'column' : 'row', // CRITICAL FIX: Stack buttons vertically on mobile
      alignItems: 'center',
      justifyContent: 'center',
      gap: '20px',
      marginTop: '40px',
      marginBottom: '20px',
    },
    primaryButton: {
      padding: '18px 50px',
      backgroundColor: '#ff007f', 
      color: '#fff',
      fontWeight: 'bold',
      border: 'none',
      fontSize: '1.2rem',
      borderRadius: '50px',
      cursor: 'pointer',
      textDecoration: 'none',
      boxShadow: '0 5px 15px rgba(255, 0, 127, 0.4)',
      transition: 'transform 0.2s, box-shadow 0.2s',
      width: isMobile ? '100%' : 'auto', // Make buttons full width on mobile
      textAlign: 'center',
      boxSizing: 'border-box',
    },
    secondaryButton: {
      padding: '18px 50px',
      backgroundColor: 'transparent', 
      color: '#f8fafc', 
      fontWeight: 'bold',
      border: '2px solid #2a3b61', 
      fontSize: '1.2rem',
      borderRadius: '50px',
      cursor: 'pointer',
      textDecoration: 'none',
      transition: 'background 0.2s, border-color 0.2s',
      width: isMobile ? '100%' : 'auto', // Make buttons full width on mobile
      textAlign: 'center',
      boxSizing: 'border-box',
    },
  };

  return (
    <div style={styles.page}>
      
      {/* --- HERO SECTION --- */}
      <div style={styles.heroSection}>
        {/* Make sure your XRayHero component handles mobile widths well internally! */}
        <XRayHero 
          bgImage={bg}
          clothedImage={charsClothed}
          secretImage={charsSecret}
          //logoImage={gameLogoImg}
        />
      </div>

      {/* --- MAIN CONTENT CARD --- */}
      <div style={styles.content}>
        
        {/* --- FLANKING CHARACTERS (ANGEL/DEVIL) --- */}
        <img 
            src={angelImg} 
            style={{...styles.flankingChar, ...styles.angelStyle}} 
            alt="Good Path" 
        />
        <img 
            src={succubusImg} 
            style={{...styles.flankingChar, ...styles.succubusStyle}} 
            alt="Evil Path" 
        />

        {/* LOGO TITLE */}
        <h1 style={styles.title}>
          {/* CRITICAL FIX: Ensure logo doesn't break mobile width */}
          <img src={gameLogoHor} style={{ maxWidth: '100%', height: 'auto', maxHeight: '150px' }} alt="3XRay Logo"/>
        </h1>
        
        <div style={styles.badgeContainer}>
          <span style={styles.badgePrimary}>Status: In Development</span>
          {/* <span style={styles.badgeSecondary}>Art: AI-Assisted (Human-Retouched)</span> */}
        </div>

        {/* UPDATED SUBTITLE */}
        <div style={styles.subtitle}>
          <p>
            When a Demon gives you the power of x-ray vision, you are met with a decision.
          </p>
          <span style={{ fontWeight: 'bold', fontSize: isMobile ? '24px' : '32px' }}>
            <span style={{color: '#03b6fc' }}>Good</span> or <span style={{color: '#ff007f' }}>evil.</span>
          </span>
          <p style={{ fontWeight: 'bold' }}>
            The choice is yours, but beware of the consequences
          </p>
        </div>

        {/* ACTION BUTTONS */}
        <div style={styles.buttonGroup}>
          <a 
            href="https://foreplaygames.itch.io/3xray"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.primaryButton}
            onClick={() => {
              // This sends the ping to Google Analytics!
              ReactGA.event({
                category: "Outbound Link",
                action: "Click_Itch",
                label: "3XRay Page" // Change this to "3XRay Page" on the other file
              });
            }}
          >
            Follow on Itch.io
          </a>
          <a 
            href="https://x.com/ForeplayGames"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.secondaryButton}
            onClick={() => {
              // This sends the ping to Google Analytics!
              ReactGA.event({
                category: "Outbound Link",
                action: "Click_Twitter",
                label: "3XRay Page" // Change this to "3XRay Page" on the other file
              });
            }}
          >
            Follow us on X / Twitter
          </a>
        </div>

        <hr style={{margin: '60px 0', border: 'none' }} />

        {/* FEATURES GRID */}
        <div style={styles.grid}>
          
          <div style={styles.featureCard}>
            <h3 style={styles.featureTitle}>👁️ X-Ray Vision</h3>
            <p style={styles.text}>
              The X-Ray vision mechanic allows you to 'investigate' any and all characters in the game. Use it to confiscate contraband,
              get a job as TSA security at the local Airport, or simply enjoy the power to see everything!
            </p>
          </div>

          <div style={styles.featureCard}>
            <h3 style={styles.featureTitle}>⚖️ Karma System</h3>
            <p style={styles.text}>
              Will you use your power to help the girls, or manipulate them for your own gain? Your choices define the route. But remember, all actions have consequences!
            </p>
          </div>

          <div style={styles.featureCard}>
            <h3 style={styles.featureTitle}>💕 20+ Girls to Choose</h3>
            <p style={styles.text}>
              With over 20 unique characters and a wide variety of personalities, backgrounds and secrets. Multiple endings featuring different characters for high replayability.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}